module.exports = __webpack_public_path__ + "static/media/green.1e0a0dc0.jpg";